import Classic from "./Classic";

export default Classic;
